/**
 * 横スクロールの矢印（2026-08-30 追加）
 * ===========================================================================
 *
 * 【なぜ要るか】
 * 「最近見た商品」(cc-recently-viewed) と**同じ見た目・同じ操作**にしたいセクションが
 * 増えたため、矢印の処理だけを取り出した。見た目のCSSは
 * `component-recently-viewed.css` をそのまま使う（クラス名も cc-rv__ を共用）。
 *
 * 「最近見た商品」との違いは、**中身をJSで取ってこない**こと。
 * こちらはLiquidが最初から商品を書き出しているので、矢印の面倒だけ見ればよい。
 *
 * 【使い方】
 *   <cc-carousel class="cc-rv …">
 *     <div class="cc-rv__viewport">
 *       <button class="cc-rv__arrow cc-rv__arrow--prev" hidden>…</button>
 *       <ul class="cc-rv__list">…</ul>
 *       <button class="cc-rv__arrow cc-rv__arrow--next" hidden>…</button>
 *     </div>
 *   </cc-carousel>
 *
 * ⚠️ 中身があとから変わることがある（並び替えのJSが余分な商品を取り除く）ので、
 *    **子要素の変化を見張って測り直す**。これをしないと矢印の出方がずれる。
 */
(function () {
  'use strict';

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  class CcCarousel extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.cc-rv__list');
      this.prevButton = this.querySelector('.cc-rv__arrow--prev');
      this.nextButton = this.querySelector('.cc-rv__arrow--next');
      if (!this.list || !this.prevButton || !this.nextButton) return;

      var update = () => {
        this.placeArrows();
        this.updateArrows();
      };
      this.update = update;

      this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
      this.nextButton.addEventListener('click', () => this.scrollByPage(1));
      this.list.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', debounce(update, 150));

      update();

      /* カードの大きさが決まる（＝画像の読み込みやCSSの適用が終わる）のを待って測り直す */
      var media = this.list.querySelector('.card__inner');
      if (media && 'ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => update());
        this.observer.observe(media);
      }

      /* 並び替えのJSが商品を取り除くので、中身が変わったら測り直す */
      if ('MutationObserver' in window) {
        this.mutation = new MutationObserver(debounce(update, 50));
        this.mutation.observe(this.list, { childList: true });
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.mutation) this.mutation.disconnect();
    }

    /* 矢印を「画像の縦中央」に置く。
       カード下部の商品名の行数は端末によって変わるので、割合ではなく画像の実寸から決める。 */
    placeArrows() {
      var media = this.list.querySelector('.card__inner');
      if (!media) return;
      var height = media.getBoundingClientRect().height;
      if (height > 0) {
        this.style.setProperty('--cc-rv-arrow-top', Math.round(height / 2) + 'px');
      }
    }

    scrollByPage(direction) {
      this.list.scrollBy({ left: direction * this.list.clientWidth, behavior: 'smooth' });
    }

    updateArrows() {
      /* 端の判定は小数の誤差が出るので少し余裕を持たせる */
      var slack = 2;
      var maxScroll = this.list.scrollWidth - this.list.clientWidth;
      var scrollable = maxScroll > slack;

      this.prevButton.hidden = !scrollable || this.list.scrollLeft <= slack;
      this.nextButton.hidden = !scrollable || this.list.scrollLeft >= maxScroll - slack;
    }
  }

  if (!customElements.get('cc-carousel')) {
    customElements.define('cc-carousel', CcCarousel);
  }
})();
